(ns frontend.ui.page.fund.investor-references.view
  (:require
   [common.localization :as loc]
   [frontend.ui.page.fund.investor-references.event :as event]
   [frontend.ui.page.fund.investor-references.sub :as sub]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.alert.view :as alert]
   [ui.components.loading-spinner.view :as spinner]))

(defn view
  [_props]
  (let [owner-id (random-uuid)
        acquire! (fn [this]
                   (rf/dispatch [::event/open (assoc (r/props this) :owner-id owner-id)]))]
    (r/create-class
     {:component-did-mount acquire!
      :component-did-update (fn [this _old-argv] (acquire! this))
      :component-will-unmount (fn [_] (rf/dispatch [::event/close owner-id]))
      :reagent-render
      (fn [_]
        (let [{:keys [loading? error]} @(rf/subscribe [::sub/status owner-id])]
          (cond
            error [alert/danger {} (loc/tr :error-loading-data)]
            loading? [:div {:class "flex items-center gap-2"
                            :aria-live "polite"}
                      [spinner/circle]
                      (loc/tr :grid-loading-data)]
            :else nil)))})))
